// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lato', 'Lato Fallback'","fontWeight":400},"className":"__className_3e3afc","variable":"__variable_3e3afc"};